import React, { ReactElement } from 'react';
import InputAnzahlHunde from './input/AnzahlHunde';
import { Grid, Typography } from '@material-ui/core';
import useWizardFormCtx from '../ctx-provider/useWizardFormCtx';
import InputHundeVersicherbar, { versicherbarVisible } from './input/HundeVersicherbar';
import FormBo from './FormBo';
import AppTranslation, { AppTranslationMessage } from "../../../../app/AppTranslation";
import InfoBtn from "../../../cmp/info/InfoBtn";
import InputHundeName from "./input/HundeName";
import InputHundeRasse from "./input/HundeRasse";
import TransitionCollapse from '../../../transition/TransitionCollapse';
import AlertFormError from '../../../../form/AlertFormError';
import TransitionFade from '../../../transition/TransitionFade';
import GtmInfoBtnId from '../../../../gtm/types/GtmInfoBtnId';

const LabelInput: React.FC<{ label: string, input: ReactElement }> = ({ label, input }) =>
    <Grid container alignItems='flex-end'>
        <Grid item xs={4} md={4}>
            <Typography variant='body1' color='textPrimary'>{label}</Typography>
        </Grid>

        <Grid item xs={8} md={8}>
            {input}
        </Grid>
    </Grid>;

const Form: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    const formBo = wizardFormBo.ihrTier;

    const hundeVersicherbarVisible = versicherbarVisible(FormBo.exportHunde(formBo));

    const hundRasseInfoTitel = AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_HUNDE_RASSE_INFO_TITEL);
    const hundRasseInfoText = AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_HUNDE_RASSE_INFO_TEXT);

    // 
    return (
        <>
            <div style={{ marginTop: 50 }}>
                <InputAnzahlHunde />
            </div>
            <div style={{ marginTop: 50 }}>
                <Grid container>
                    {
                        formBo.hunde.map((hund, index) => (
                            <TransitionCollapse show={formBo.anzahlHunde > index} key={index}>
                                <Grid item xs={12} md={12} container style={{ marginBottom: formBo.anzahlHunde === index + 1 ? 0 : 40 }}>
                                    <Grid item xs={12} md={12}>
                                        <TransitionCollapse show={wizardFormBo.ihrTier.anzahlHunde > 1}>
                                            <Typography variant='h5' color='textPrimary' display='inline' style={{ marginRight: 10 }}>{`Mein ${index + 1}. Hund`}</Typography>
                                        </TransitionCollapse>
                                    </Grid>

                                    {/* Hund: Name */}
                                    <Grid item xs={12} md={12} container alignItems='flex-end'>
                                        <Grid item xs={11} md={11}>
                                            <LabelInput label={wizardFormBo.ihrTier.anzahlHunde > 1 ? 'heißt' : 'Mein Hund heißt'} input={<InputHundeName index={index + 1} />} />
                                        </Grid>
                                    </Grid>

                                    {/* Hund: Rasse */}
                                    <Grid item xs={12} md={12} container alignItems='flex-end' style={{ marginTop: 16 }}>
                                        <Grid item xs={11} md={11}>
                                            <LabelInput label='und ist ein' input={<InputHundeRasse index={index + 1} />} />
                                        </Grid>
                                        <Grid item xs={1} md={1} style={{ textAlign: 'left' }}>
                                            <InfoBtn titel={hundRasseInfoTitel} text={hundRasseInfoText} gtmId={GtmInfoBtnId.HUNDE_RASSE} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TransitionCollapse>
                        ))
                    }
                </Grid>

            </div>
            <div style={{ marginTop: 30, minHeight: 80 }}>
                <Grid container>
                    <TransitionFade show={hundeVersicherbarVisible}>
                        <Grid item xs={12} md={12} container alignItems='center'>
                            <Grid item xs={11} md={11}>
                                <InputHundeVersicherbar />
                            </Grid>
                            <Grid item xs={1} md={1}>
                                <InfoBtn titel={hundRasseInfoTitel} text={hundRasseInfoText} gtmId={GtmInfoBtnId.HUND_VERSICHERBAR} />
                            </Grid>
                        </Grid>
                    </TransitionFade>
                </Grid>
            </div>

            <div style={{ marginTop: 10 }}>
                {formBo.anzahlHunde > 1 && <AlertFormError />}
            </div>

        </>
    );
}

export default Form;